import React from 'react';
import {DropdownHandler, Icon} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';

type Props = {onPress: () => void};

const ClientContactMenuItem = ({onPress}: Props): JSX.Element => {
	const {formatMessage} = useIntl();
	return (
		<DropdownHandler.Item onClick={onPress} data-cy="create-new-client-contact">
			<Icon icon="shared" size="m" />
			{formatMessage({id: 'common.contact'})}
		</DropdownHandler.Item>
	);
};

export default ClientContactMenuItem;
